export default __webpack_public_path__ + "static/media/List-documentation.0ebe6c68.md";